









































































































import { Action, Mutation, State, Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import { MessageService } from '@/services/messageService';
import {
  GET_USER_BONDS,
  GET_SELECTED_USER,
  UPDATE_CURRENT_USER_TAB,
  UPDATE_SELECTED_BOND,
  DELETE_USER_BONDS,
  FETCH_USER_BONDS_LIST,
  UPDATE_USER_BONDS,
} from '@/modules/user/store';
import { IBond } from '@/models/Bond';
import { IUser, userTabs } from '@/modules/user/models';

@Component
export default class extends Vue {
  public search: string = '';
  public isLoading: boolean = false;
  public bondsToDelete: number[] = [];
  public headersStores: any[] = [
    { text: '', value: '' },
    { text: 'Tipo Vínculo', value: 'bondtype' },
    { text: 'Valor', value: 'value' },
    { text: 'Descrição', value: 'description' },
    { text: 'Status', value: 'isactive' },
  ];
  public newBond: IBond = {
    idbond: 0,
    bondtype: '',
    name: '',
    isactive: true,
    description: '',
    identifiernumber: '',
    value: '',
    idbondtype: 0,
    idstorebpa: 0,
    valueBpa: '',
    selected: false,
  };

  @Getter(GET_SELECTED_USER)
  public userSelected: IUser;

  @Getter(GET_USER_BONDS)
  public userBonds: IBond[];

  @Action(UPDATE_SELECTED_BOND)
  public setSelectedBond: any;

  @Action(UPDATE_CURRENT_USER_TAB)
  private setCurrentTab: any;

  @Action(UPDATE_CURRENT_USER_TAB)
  private setUserCurrentTab: any;

  @Action(DELETE_USER_BONDS)
  private deleteUserBonds: any;

  @Action(FETCH_USER_BONDS_LIST)
  private getUserBonds: any;

  @Action(UPDATE_USER_BONDS)
  private setUserBonds: any;

  public getBadgeColor(icatv: boolean) {
    return icatv ? 'teal' : 'red';
  }

  public selectBond(bond: IBond) {
    this.setSelectedBond(bond);
    this.setUserCurrentTab(userTabs.tabs.registerbondtab);
  }

  public createNewBond() {
    this.setSelectedBond({ isactive: true });
    this.setCurrentTab(userTabs.tabs.registerbondtab);
  }

  public hasBondSelected() {
    return this.userBonds.some((c) => c.selected);
  }

  public deleteBonds() {
    const ids = this.userBonds.filter((c) => c.selected).map((c) => c.idbond);
    const obj = { bondIds: ids, id: this.userSelected.id };

    this.deleteUserBonds(obj).then(() => {
      this.getUserBonds(this.userSelected.id).then((ret: any) => {
        MessageService.Success('Sucesso', 'Vínculos removidos com sucesso.');
        this.setUserBonds(ret.data);
      });
    });
  }
}
